let Api = {
  FARMPROJECTVARIETY_DELBYID : "/difam/w/farmProjectVariety/delById", // 根据ID删除信息
  FARMPROJECTVARIETY_FINDLIST : "/difam/w/farmProjectVariety/findList", // 项目建设情况列表
  FARMPROJECTVARIETY_GETDETAIL : "/difam/w/farmProjectVariety/getDetail", // 查询项目建设情况
  FARMPROJECTVARIETY_SAVE : "/difam/w/farmProjectVariety/save", // 保存项目建设情况信息(2060养殖情况/家庭牧场情况/闲散养殖点情况)
};
module.exports = Api;
